<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  export let key;
  export let catName;
  export let itemName;
  export let itemPrice;
  export let itemQuantity;
  export let itemImgPath;

  function passUpdateKey() {
    dispatch("BillItemUpdate", {
      key: key
    });
  }
  function passDeleteKey() {
    dispatch("BillItemDelete", {
      key: key
    });
  }
</script>

<style>
  tr {
    white-space: nowrap;
  }
  .category-name {
    display: block;
    width: 50%;
    font-family: monospace;
    font-size: 0.875rem;
    font-weight: bold;
    color: rgb(97, 97, 90);
    background-color: rgb(242, 245, 89);
    padding: 2px 2px;
    border-radius: 30px;
    margin-top: 2px;
    text-align: center;
  }
</style>

<tr>
  <td style="width:20%; padding:3px; font-weight:bold;">
    {itemName}
    <img
      alt={itemName}
      src="../images/{itemImgPath}"
      width="48"
      height="48"
      style="float:right" />
    <span class="category-name">{catName}</span>
  </td>
  <td style="width:25% ; font-weight:bold;">{itemPrice}</td>
  <td id="q{key}" style=" padding:1px">
    <input
      style=" margin:4px 2px; "
      type="number"
      size="6"
      min="1"
      max="100"
      bind:value={itemQuantity}
      on:input={passUpdateKey} />
    <!-- <input type="number" bind:value={itemQuantity} onchange={passKey} /> -->
  </td>
  <td style="width:10% ; padding:1px">
    <button
      style="margin:0px auto; color:red; background-color:yellow;"
      on:click={passDeleteKey}>
      X
    </button>
  </td>
</tr>
